import React, { useContext } from 'react';
import { AppBar, MenuItem } from '@mui/material';
import { useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Menu as MenuIcon } from 'lucide-react';
import './navbar.css';
import styled from '@emotion/styled';
import { Dropdown } from '../muiCustomized/Dropdown';
import ShootLogo from '../../images/blue-shoot-logo.png';
import UserSVG from '../../images/user.svg';
import MyAccount from '../../images/myAccount.svg';
import SwitchAccount from '../../images/switchAccount.svg';
import LogOut from '../../images/logout.svg';
import { UserContext } from '../../contexts/User';
import DownloadAppLink from '../utils/LinkWithQueryParams';
import ImpersonationBanner from '../ImpersonationBanner';
import SubscriptionBanner from '../SubscriptionBanner';
import NotificationBell from '../notifications/NotificationBell';

const Avatar = styled.div`
  border-radius: 9999px;
  width: 32px;
  height: 32px;
  background: var(--dark-7);
  color: var(--dark-3);
  flex-shrink: 0;
  ${(props) => props.src && `
    background-size: cover;
    background-position: center;
    background-image: url(${props.src});
  `}
`;

const CustomizedMenuItem = styled(MenuItem)`
  && {
    background-color: white;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &&:hover {
    background-color: var(--dark-8);
  }
`;

export function Navbar() {
  const {
    user, member, signOut,
  } = useContext(UserContext);
  const history = useHistory();
  const roleLabel = member?.role?.name || member?.accountType || 'Member';

  return (
    <div className="navbar-holder">
      <AppBar position="static" sx={{ boxShadow: 'none' }} color="inherit">
        <div className="navbar-between">
          <div className="navbar-left">
            <button
              type="button"
              className="navbar-hamburger"
              aria-label="Toggle navigation"
              onClick={() => window.dispatchEvent(new CustomEvent('shoot:toggle-sidenav'))}
            >
              <MenuIcon size={20} />
            </button>
            <img
              src={ShootLogo}
              height="33"
              className="navbar-logo"
              alt="shoot-logo"
            />
            <ImpersonationBanner />
            <SubscriptionBanner inline />
          </div>
          <div className="user-menu">
            <NotificationBell />
            <div className="user-menu-info">
              <p className="user-menu-name">
                {user.firstName}
                {' '}
                {user.lastName}
              </p>
              <p className="user-menu-role">{roleLabel}</p>
            </div>
            <Dropdown
              displayEmpty
              renderValue={() => (
                <Avatar
                  className="user-menu-avatar"
                  src={user.profilePicture || UserSVG}
                />
              )}
              setValue={() => {}}
              className="user-menu-dropdown"
            >
              <CustomizedMenuItem dense onClick={() => history.push('/account')}>
                <img src={MyAccount} alt="my account" />
                My Account
              </CustomizedMenuItem>
              <CustomizedMenuItem dense>
                <img src={SwitchAccount} alt="switch accounts" />
                Switch Accounts
              </CustomizedMenuItem>
              <CustomizedMenuItem dense onClick={signOut}>
                <img src={LogOut} alt="log out" />
                <span style={{ color: 'var(--red-2)' }}>Log Out</span>
              </CustomizedMenuItem>
              <CustomizedMenuItem dense>
                <DownloadAppLink>
                  <img src={ShootLogo} alt="download app" style={{ height: 20, marginRight: 8 }} />
                  Download App
                </DownloadAppLink>
              </CustomizedMenuItem>
            </Dropdown>
          </div>
        </div>
      </AppBar>
    </div>
  );
}
